module.exports = __webpack_public_path__ + "img/net-a-porter_0.165deceb.jpg";